import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent, DesignBlockTextAndMediaScope, WebsiteBlockImageAction, WebsitePageScope } from '@sb/library/base';
import { UniqueID, WebsiteBlockDisplayItem, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaImageDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';
import { Scope, Field } from '@sb/library/base';

export class PhotoGalleryDesignBlockScope extends DesignBlockTextAndMediaScope {
    middleImageIndex = Field<number>();
    HandleImageAction = Field<(block: WebsiteBlockDisplayItem.WithImages, action: WebsiteBlockImageAction, index: number) => void>();
}

@Component({
    selector: 'lib-photo-gallery-design-block',
    templateUrl: './photo-gallery-design-block.component.html',
    styleUrls: ['./photo-gallery-design-block.component.scss']
})

export class PhotoGalleryDesignBlockComponent extends DesignBlockBaseViewComponent implements PhotoGalleryDesignBlockScope {

    override Scope = this.SetScope({
        Implements: PhotoGalleryDesignBlockScope,
        Requires: WebsitePageScope
    });

    @Input() websiteBlockData!: WebsiteBlockTextAndMediaDisplayItem;

    middleImageIndex: number = 1;

    private _swipeTouchStartCoord!: [number, number];
    private _swipeTouchStartTime!: number;

    Swipe(e: TouchEvent, isTouchStartEvent: boolean): void {

        if (this.type !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid) {

            const touchCoord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
            const time: number = new Date().getTime();

            if (isTouchStartEvent) {
                this._swipeTouchStartCoord = touchCoord;
                this._swipeTouchStartTime = time;
            } else {
                const swipeDirection = [touchCoord[0] - this._swipeTouchStartCoord[0], touchCoord[1] - this._swipeTouchStartCoord[1]];
                const swipeDuration = time - this._swipeTouchStartTime;

                if (swipeDuration < 1000
                    && Math.abs(swipeDirection[0]) > 30 // delta X (horizontal distance) threshold
                    && Math.abs(swipeDirection[0]) > Math.abs(swipeDirection[1] * 3) // delta X > delta Y (more horizontal vs vertical enough) threshold -
                ) {
                    const swipeRight = swipeDirection[0] < 0;

                    if (swipeRight) {
                        this.Next();
                    } else {
                        this.Previous();
                    }
                }
            }
        }
    }

    HandleImageAction(block: WebsiteBlockDisplayItem.WithImages, action: WebsiteBlockImageAction, index: number) {
        this.Scope.HandleImageAction(block, action, index);
        if (action === WebsiteBlockImageAction.Delete) {
            if (block.Images.length < 3) {
                block.Images.splice(index, 0, new WebsiteBlockTextAndMediaImageDisplayItem({ WebsiteMediaLibraryItemID: UniqueID() }));
            } else if (this.middleImageIndex >= block.Images.length) {
                this.middleImageIndex--;
            }
        } else if (action === WebsiteBlockImageAction.MoveLeft && this.images.length > 3 && index === this.BoundedIndex(this.middleImageIndex - 1)) {
            if (index === 0) {
                this.middleImageIndex = this.images.length - 2;
            } else {
                this.Previous();
            }
        } else if (action === WebsiteBlockImageAction.MoveRight && this.images.length > 3 && index === this.BoundedIndex(this.middleImageIndex + 1)) {
            if (index === this.images.length - 1) {
                this.middleImageIndex = 1;
            } else {
                this.Next();
            }
        }
    }

    Next(): void {
        this.middleImageIndex = this.BoundedIndex(this.middleImageIndex + 1);
    }

    Previous(): void {
        this.middleImageIndex = this.BoundedIndex(this.middleImageIndex - 1);
    }

    BoundedIndex(index: number) {
        return (index + this.images.length) % this.images.length;
    }

    get type(): WebsiteBlockTextAndMediaType {
        return this.websiteBlockData.TextAndMediaType;
    }

    get images(): WebsiteBlockTextAndMediaImageDisplayItem[] {
        return this.websiteBlockData.Images;
    }
}
